import { ComponentProps } from 'react';
import styled from 'styled-components';

export type IconProps = ComponentProps<typeof Svg>;

const Icon = (props: IconProps) => (
  <Svg
    fill="none"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  />
);

const Svg = styled.svg`
  display: block;
  color: inherit;
  transition: color 0.3s ease-in-out;
`;

export { Icon };
